import { PROCEDURE_APPOINTMENT_CODES } from '@bariendo/lib/constants';

/** Retool's list includes IGB removal; the shared procedure-stage list does not. */
export const PREPROCEDURE_APPOINTMENT_CODES = [...PROCEDURE_APPOINTMENT_CODES, 'igb-removal-procedure'] as const;

export const PROCEDURE_DISPLAY: Record<string, string> = {
  'esg-procedure': 'ESG Procedure',
  'esg-max-procedure': 'ESG Max Procedure',
  'sis-procedure': 'SIS Procedure',
  'tore-regular-procedure': 'TORe Regular Procedure',
  'tore-plus-procedure': 'TORe Plus Procedure',
  'igb-placement-procedure': 'IGB Placement Procedure',
  'igb-removal-procedure': 'IGB Removal Procedure',
};

export const MILESTONE_CODES = [
  'initial-wellness-visit',
  'group-visit-with-your-doctor',
  'iv-therapy',
  'post-procedure-wellness-check',
] as const;
export type MilestoneCode = (typeof MILESTONE_CODES)[number];
/** For PPD1 the first booking counts; for the rest the latest does (Retool `earliestWins`). */
export const EARLIEST_WINS_MILESTONES: ReadonlySet<MilestoneCode> = new Set(['post-procedure-wellness-check']);

export const PREPROCEDURE_TASK_CODES = [
  'clearance',
  'labOrders',
  'infoCollected',
  'needsMonitoring',
  'facilityPaperwork',
  'anesthesiaBooking',
  'labsSent',
  'scaleOrdered',
] as const;
export type PreprocedureTaskCode = (typeof PREPROCEDURE_TASK_CODES)[number];

/** Retool `locationsRequiringAnesthesiaBooking`. Matched against the Location display name. */
export const LOCATIONS_REQUIRING_ANESTHESIA_BOOKING: ReadonlySet<string> = new Set([
  'Greater Miami',
  'Greater Miami - SurgiCare',
  'Greater Jacksonville',
]);

export const LAB_ORDER_CATEGORY = '108252007';
export const LAB_REVIEW_PLAN_DEFINITION_URL = 'http://bariendo.com/fhir/PlanDefinition/app-lab-review';
export const LAB_REVIEW_QUESTIONNAIRES: ReadonlySet<string> = new Set([
  'Questionnaire/app-labs-reviewed',
  'Questionnaire/app-lab-review',
]);
export const HEALTHIE_LAB_REVIEW_FORM_NAMES: ReadonlySet<string> = new Set(['APP - Labs Reviewed', 'APP - Lab review']);
export const HEALTHIE_DATA_EXTENSION = 'http://bariendo.com/fhir/extension/data-from-healthie';
export const DOSESPOT_STATUS_EXTENSION = 'https://dosespot.com/prescription-status';
export const SCALE_MANUFACTURER = 'MioConnect';
export const ET_TIMEZONE = 'America/New_York';
